import { CmsGroupMarketingPreferencesFieldset } from '../../models/group-marketing-preferences/cms-group-marketing-preferences-fieldset.interface';

export const mockCmsGroupMarketingPreferencesFieldset: CmsGroupMarketingPreferencesFieldset =
  {
    groupMarketingConsentField: {
      fieldLabel: 'Group marketing consent',
      fieldRequired: true,
    },
    fieldsetLegend: 'Your registration details',
    fieldsetLegendDisplayAsLabel: true,
    fieldsetLegendNote:
      'Please confirm you are happy for us to use your information and preferences for your registrations with {{ brandNames }} to be used as described in the privacy policies below',
  };
